/*
 * This file is part of Invenio-RDM-Records
 * Copyright (C) 2020-2023 CERN.
 * Copyright (C) 2020-2022 Northwestern University.
 *
 * Invenio-RDM-Records is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

import _cloneDeep from "lodash/cloneDeep";
import _get from "lodash/get";
import _set from "lodash/set";

import { Field } from "./Field";

/**
 * Serializer for the custom multi-value ``metadata.resource_types`` field.
 *
 * The API representation is an array of vocabulary objects:
 *
 *   [{ id: "dataset" }, { id: "software" }]
 *
 * The Semantic UI multi-select used by ``ResourceTypeField`` requires an array
 * of primitive option values:
 *
 *   ["dataset", "software"]
 */
export class ResourceTypesField extends Field {
  deserialize(record) {
    const fieldValue = _get(record, this.fieldpath, this.deserializedDefault);

    if (fieldValue === null || fieldValue === undefined) {
      return _set(_cloneDeep(record), this.fieldpath, this.deserializedDefault);
    }

    const values = Array.isArray(fieldValue) ? fieldValue : [fieldValue];
    const deserializedValue = values
      .map((value) => (typeof value === "string" ? value : value?.id))
      .filter(Boolean);

    return _set(_cloneDeep(record), this.fieldpath, deserializedValue);
  }

  serialize(record) {
    const fieldValue = _get(record, this.fieldpath, this.serializedDefault);

    if (fieldValue === null || fieldValue === undefined) {
      return _set(_cloneDeep(record), this.fieldpath, this.serializedDefault);
    }

    const values = Array.isArray(fieldValue) ? fieldValue : [fieldValue];
    const serializedValue = values
      .map((value) => {
        if (typeof value === "string") {
          return { id: value };
        }
        return value?.id ? { id: value.id } : null;
      })
      .filter(Boolean);

    return _set(_cloneDeep(record), this.fieldpath, serializedValue);
  }
}
